// extracted by mini-css-extract-plugin
export var container = "_c2-0";
export var icon = "_c2-1";
export var text = "_c2-2";